import SquadSemiBoldText from './SquadSemiBoldText';

export default SquadSemiBoldText;
